import type {
  InsulinActivity,
  DeepPartial,
} from "@tandemdiabetes/sugarmate-api-react-client"
import {
  Dropdown,
  DropdownCaret,
  DropdownCurrentSelection,
  DropdownOption,
  DropdownSelect,
} from "@tandemdiabetes/sugarmate-react-components"
import type { ChangeEventHandler } from "react"
import { useCallback } from "react"

import styles from "./InsulinFormNameSelect.module.scss"
import { useNameSelectOptions } from "./useNameSelectOptions"

interface Props {
  activity?: DeepPartial<InsulinActivity>;
  updateActivity: (a: DeepPartial<InsulinActivity>) => void;
}

/*
 * renders a select element for choosing insulin name
 */
export function InsulinFormNameSelect(props: Props) {
  const {
    activity,
    updateActivity,
  } = props

  // calculate the options for the select menu
  const selectOptions = useNameSelectOptions()

  // save changes to account_insulin_id
  const onInsulinChange: ChangeEventHandler<HTMLSelectElement> = useCallback(
    (e) => {
      const accountInsulinId = Number(e.target.value)

      updateActivity({
        num_units: activity?.insulin_med
          ? undefined
          : activity?.num_units,
        insulin_med: {
          account_insulin_id: accountInsulinId,
        },
      })
    },
    [
      activity,
      updateActivity,
    ],
  )

  return (
    <Dropdown className={styles.container}>
      <DropdownSelect
        value={
          activity?.insulin_med?.account_insulin_id === undefined
            ? ""
            : `${activity.insulin_med?.account_insulin_id}`
        }
        onChange={onInsulinChange}
        required
        id="insulin-name-dropdown"
      >
        {selectOptions.map(
          (selectOption) => (
            <DropdownOption
              key={selectOption.value}
              value={selectOption.value}
              disabled={selectOption.disabled}
            >
              {selectOption.children}
            </DropdownOption>
          ),
        )}
      </DropdownSelect>
      <DropdownCurrentSelection />
      <DropdownCaret />
    </Dropdown>
  )
}
